module.exports = __webpack_public_path__ + "static/media/FahmidaRiaz2.a7cceb45.jpeg";